$(function(){
    var agent = navigator.userAgent;
    var IE6 = (navigator.userAgent.indexOf("MSIE 6")>=0) ? true : false;
    var IE7 = (navigator.userAgent.indexOf("MSIE 7")>=0) ? true : false;

    if (agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1 || (IE6) || (IE7)){
        // hide js-scroll-header class
        $('.js-scroll-header').hide();
    } else{
        $('.js-scroll-header').hide();
        // scroll case
        $(window).scroll(function(){
            // scroll 300 over case
            if ($(this).scrollTop() > 300) {
                // fade-in js-scroll-header class
                $('.js-scroll-header').fadeIn();
            }
            // scroll 300 less case
            else {
                // fade-out js-scroll-header class
                $('.js-scroll-header').fadeOut();
            }
        });
    }
});